import type { Schema } from '@empathyco/x-adapter'

import type { SearchResponse } from '../types'
import { hierarchicalFacetSchema } from './hierarchical-facet.schema'
import { resultSchema } from './result.schema'

export const searchResponseSchema: Schema<any, SearchResponse> = {
  results: {
    $path: 'catalog.content',
    $subSchema: resultSchema,
  },
  totalResults: 'catalog.numFound',
  facets: {
    $path: 'catalog.facets',
    $subSchema: hierarchicalFacetSchema,
  },
}
